import { render, staticRenderFns } from "./TemperatureHandbook.vue?vue&type=template&id=35b6933c"
import script from "./TemperatureHandbook.vue?vue&type=script&lang=js"
export * from "./TemperatureHandbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports